import {
  id,
  allocation,
  Identifiable,
  Allocation,
  status,
  Status,
} from "@planzone/dto";
import { Event, events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { createStateReducer } from "../../utils/createStateReducer";
import { reduceResource } from "../resource";

const initialState = { ...status, uuid: id };

function handleEditRequest(
  status: Identifiable<Status>,
  req: Boundaries["editTaskStatus"]["request"],
) {
  return status.uuid === req.status.uuid
    ? { ...status, ...req.nextStatus }
    : status;
}

function handleEditSuccess(
  status: Identifiable<Status>,
  nextStatus: Boundaries["editTaskStatus"]["success"],
) {
  return status.uuid === nextStatus.uuid
    ? { ...status, ...nextStatus }
    : status;
}

function handleEditFailure(
  status: Identifiable<Status>,
  req: Boundaries["editTaskStatus"]["failure"],
) {
  return status.uuid === req.status.uuid ? req.status : status;
}

const reduceTaskStatus = createStateReducer(initialState, {
  [events.editTaskStatusRequested]: handleEditRequest,
  [events.editTaskStatusSucceeded]: handleEditSuccess,
  [events.editTaskStatusFailed]: handleEditFailure,
});

export { reduceTaskStatus };
